<app-header></app-header>
<section class="inerpages-banner">
  <img src="{{ imgurl }}{{ bnrAr['picture'] }}" class="w-100" />
  <div class="fade-bg"></div>
  <div class="mask-content-v-center text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-12"> 
          <div
            class="tbox-iner text-center animate zoomIn"
            data-anim-type="zoomIn"
          >
            <div class="heading-iner">
              <h2 *ngIf="showLang == 'en'">{{ bnrAr["smallCaption"] }}</h2>
              <h2 *ngIf="showLang == 'ar'">{{ bnrAr["smallCaption_ar"] }}</h2>

              <hr />
              <p *ngIf="showLang == 'en'">{{ bnrAr["bigCaption"] }}</p>
              <p *ngIf="showLang == 'ar'">{{ bnrAr["bigCaption_ar"] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="checkout-page py-5">
  <div class="container">
    <div class="row">
      <div class="your-cart col-md-4 order-md-2 mb-4">
        <ul class="list-group mb-3">
          <li class="list-group-item">
            <h4 class="d-flex justify-content-between align-items-center mt-2">
              <span class="text-muted">{{
                "checkout.your_cart" | translate
              }}</span>
              <span class="badge badge-secondary badge-pill">{{
                storedCart.length
              }}</span>
            </h4>
          </li>
          <li
            class="list-group-item d-flex justify-content-between lh-condensed"
            *ngFor="let cart of storedCart"
          >
            <div>
              <h6 class="my-0" *ngIf="showLang == 'en'">{{ cart.pName }}</h6>
              <h6 class="my-0" *ngIf="showLang == 'ar'">{{ cart.pName_ar }}</h6>

              <h6
                class="my-0 addi-info"
                *ngIf="cart.pComent && cart.pComent != ''"
              >
                (Additional Instruction: {{ cart.pComent }})
              </h6>
            </div>
            <span class="text-muted">AED {{ cart.totalPrice }}</span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total"> {{ "cart.cart_total" | translate }} </span>
            <strong>AED {{ this.total }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total">{{
              "checkout.cutlery_needed" | translate
            }}</span>
            <strong>{{ cutlery | uppercase }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total">{{
              "checkout.delivery_charge" | translate
            }}</span>
            <strong>+ AED {{ this.shipChrage }} </strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>
              <strong>{{ "checkout.total_amount" | translate }} :</strong>
            </dt>
            <dd class="text-right">
              <strong> AED {{ this.totalWithShiping }} </strong>
            </dd>
          </li>

          <li
            class="list-group-item d-flex justify-content-between bg-light"
            *ngIf="cpnCode != ''"
          >
            <div class="text-success">
              <h6 class="my-0">{{ "checkout.promo_code" | translate }}</h6>
              <small>{{ cpnCode }}</small>
            </div>
            <span class="text-success">- AED {{ discountedAmount }}</span>
            <button class="btn remove-coupon comm-btn" (click)="removeCpn()">
              <i class="fas fa-trash-alt" aria-hidden="true"></i>
            </button>
          </li>

          <li
            class="list-group-item d-flex justify-content-between bg-light"
            *ngIf="usedPrice"
          >
            <div class="text-success">
              <h6 class="my-0">
                {{ "checkout.reward_points" | translate }}
                <button
                  class="btn btn-danger remove-coupon comm-btn"
                  (click)="removeRewardPoints()"
                >
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
              </h6>
            </div>

            <span class="text-success">- AED {{ usedPrice }}</span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>
              <strong>{{ "checkout.net_payable" | translate }}</strong>
            </dt>
            <dd class="text-right">
              <strong>AED {{ this.netPayable }}</strong>
            </dd>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>{{ "checkout.included_tax" | translate }} (5%)</dt>
            <dd class="text-right">AED {{ this.taxAmt }}</dd>
          </li>
        </ul>

        <!-- <ul class="list-group coupon-appli">
          <h4>
            <span class="text-muted">
              {{ "checkout.your_points" | translate }}
            </span>
          </h4>
          <p class="mt-3">
            {{ "checkout.avl_points" | translate }}: {{ rewardPoints }}
          </p>

          <button
            (click)="redeemReward()"
            [disabled]="isRedeem"
            class="btn Shopping-btn Cout-btn"
          >
            {{ "checkout.redeem" | translate }}
            <span *ngIf="isRedeemLoading">
              <i class="fas fa-circle-notch fa-spin"></i>
            </span>
          </button>

          <div *ngIf="isrewardMsg">
            <p class="mt-3 text-danger">
              {{ "checkout.coupon_msg" | translate }}
            </p>
            <a class="btn remove-coupon comm-btn" (click)="removeCpn()">{{
              "checkout.remove_coupon" | translate
            }}</a>
          </div>
        </ul> -->
      </div>
      <div class="billing-details col-md-8 order-md-1">
        <h2 class=""> {{ "checkout.billing_det" | translate }}</h2>

        <form>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="name">{{ "checkout.t_name" | translate }}<span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="name"
                name="uname"
                placeholder="Name"
                [(ngModel)]="uname"
              />
            </div>

            <div class="form-group col-md-6">
              <label for="email">{{ "checkout.t_email" | translate }}</label>
              <input
                type="email"
                class="form-control"
                id="email"
                name="email"
                placeholder="Email"
                [(ngModel)]="userEmail"
              />
            </div>
          </div>

          <div class="form-group">

            <label for="inputAddress">{{ "checkout.t_mobile" | translate }}<span class="text-danger">*</span></label>
            <span class="country-code">971</span>
            <input
              type="text"
              class="form-control phone-country"
              id="mobile"
              name="userPhone"
              placeholder="501234567"
              [(ngModel)]="userPhone"
            />
            <p *ngIf="phoneerrmsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
              {{ phoneerrmsg }}
            </p>
            <p *ngIf="phoneerrmsg != '' && showLang == 'ar'" class="text-danger text-right  valid-danger-text mt-3">
              {{ phoneerrmsg_ar }}
            </p>
          </div>

          <div class="form-group">
            <label for="inputAddress">{{ "checkout.t_address" | translate }}<span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              #search
              id="inputAddress"
              placeholder="1234 Main St"
              name="address_1"
              (keyup)="onChanegAddress($event.target.value)"
              [(ngModel)]="address_1"
            />
            <p *ngIf="addrerrmsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
              {{ addrerrmsg }}
            </p>
            <p *ngIf="addrerrmsg != '' && showLang == 'ar'" class="text-danger text-right  valid-danger-text mt-3">
              {{ addrerrmsg_ar }}
            </p>
            
          </div>
          <div class="form-group">
            <label for="inputAddress2"> {{ "checkout.t_full_address" | translate }}<span class="text-danger">*</span> </label>
            <input
              type="text"
              class="form-control"
              id="inputAddress2"
              placeholder="Apartment, studio, or floor"
              name="address_2"
              [(ngModel)]="address_2"
            />
            <p *ngIf="addr2errmsg != '' && showLang == 'en'" class="text-danger  valid-danger-text mt-3">
              {{ addr2errmsg }}
            </p>
            <p *ngIf="addr2errmsg != '' && showLang == 'ar'" class="text-danger text-right valid-danger-text mt-3">
              {{ addr2errmsg_ar }}
            </p>
          </div>
          <div class="form-group">
            <label for="inputAddress2">{{ "checkout.t_villa_appartment" | translate }}<span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="inputAddress2"
              placeholder="Villa or apartment number"
              name="apartment"
              [(ngModel)]="apartment"
            />
            <p  *ngIf="errmsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
              {{ errmsg }}
            </p>
            <p  *ngIf="errmsg != '' && showLang == 'ar'" class="text-danger text-right valid-danger-text mt-3">
              {{ errmsg_ar }}
            </p>
            
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="country">{{ "checkout.t_country" | translate }}<span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="country"
                name="country"
                [(ngModel)]="country"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="state">{{ "checkout.t_state" | translate }}<span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="state"
                name="state"
                [(ngModel)]="state"
              />
            </div>
            <div class="form-group col-md-2">
              <label for="city">{{ "checkout.t_city" | translate }}<span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="city"
                name="city"
                [(ngModel)]="city"
              />
            </div>
          </div>
        </form>
      
        <p *ngIf="outofZone" class="shop-closed" >
          Sorry, This order cannot be delivered on this location.
          <!-- {{ "cart.donot_deliver" | translate }} -->
        </p>

      <input type="checkbox" id="pickup" class="mr-1" 
        (change)="pickUPstore(pickup)"
       #pickup />
       <label class="schedeli" for="pickup"> Pick up from store </label>
       <br>
       <select *ngIf="pickUp==1" name="pickbranch" class="form-control" #pickbranch  (change)="getBranchName(pickbranch.value)">
        <option>Select pick up branch </option>
        <option value="Tourist Club" >Tourist Club</option>
        <option value="Cournish" >Cournish</option>
    </select>
      <p *ngIf="branchMsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
        {{ branchMsg }}
      </p>



        <input
          type="checkbox"
          class="mr-1"
          id="delSch"
          [checked]="chkIsFeast"
          (change)="scheduleDelivery(showDevlivery)"
          #showDevlivery
        />
        <label class="schedeli" for="delSch">{{
          "checkout.shedule_delivery" | translate
        }}</label>
        <div *ngIf="showscheduleDelivery">
          <form class="form-inline">
            <div class="form-group mx-sm-6 mb-2">
              <input
                type="date"
                class="form-control date-from"
                name="dl_date"
                (change)="getDate(date.value)"
                placeholder="Choose date"
                [value]="orderfeastDate"
                #date
              />
            </div>

            <div class="form-group mx-sm-6 mb-2">
              <select
                name="from_time"
                class="form-control date-from"
                (change)="getfromTime(fromtime.value)"
                #fromtime
              >
                <option value="">{{ "checkout.from_time" | translate }}</option>
                <option
                  *ngFor="let timing of timings"
                  [value]="timing"
                  [selected]="orderfeastTime == timing"
                >
                  {{ timing }}
                </option>
              </select>
            </div>
          </form>
          <p
            *ngIf="schMsg != '' && showLang == 'en'"
            class="text-danger valid-danger-text mt-3"
          >
            {{ schMsg }}
          </p>
          <p
            *ngIf="schMsg != '' && showLang == 'ar'"
            class="text-danger valid-danger-text mt-3"
          >
            {{ schMsg_ar }}
          </p>
        </div>

         <div>
          <h6>Delivery Instructions</h6>
          <input class="form-control" type="text" name="del_inst"  #del_inst>
        </div>
        <div class="donotdeliver" *ngIf="!outofZone">
        <div class="billing-details mt-3" *ngIf="shopStatus == 0">
          <h2 class="mb-3">{{ "checkout.make_payment" | translate }}</h2>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="pills-home-tab"
                data-toggle="pill"
                href="#credit-card"
                role="tab"
                (click)="getPaymentMethod('Card')"
                aria-controls="pills-home"
                aria-selected="true"
                >{{ "checkout.card" | translate }}</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="pills-profile-tab"
                data-toggle="pill"
                href="#cashon-delivery"
                (click)="getPaymentMethod('COD')"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
                >{{ "checkout.cashon_delivery" | translate }}</a
              >
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="credit-card"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <form
                id="payment-form"
                method="POST"
                action="{{ API_URL }}make-payment"
                #f="ngForm"
              >
                <div class="card-frame">
                  <!-- form will be added here -->
                </div>
                <!-- add submit button -->

                <input
                  type="hidden"
                  value="{{ this.cardAmount }}"
                  name="amount"
                />
                <input
                  type="hidden"
                  value="{{ lastOrderId }}"
                  name="order_id"
                />

                <button
                  class="btn btn-lg Shopping-btn btn-block d-none"
                  id="pay-button"
                  disabled
                  (click)="onPaymentClick(del_inst.value)"
                  #paybtn
                >
                  PAY AED {{ this.netPayable }}
                </button>
              </form>
              <button
                class="btn btn-lg Shopping-btn pay-button"
                id="pay_button_custom"
                [disabled]="
                  !uname ||
                  !userPhone ||
                  !address_1 ||
                  !address_2 ||
                  !city ||
                  !state ||
                  !country
                "
                (click)="onPaymentClick(del_inst.value)"
              >
                PAY AED {{ this.netPayable }}
                <span *ngIf="isLoading">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </span>
              </button>
            </div>
            <div
              class="tab-pane fade"
              id="cashon-delivery"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <button 
                class="btn-lg Shopping-btn btn-block"
                [disabled]="isCodClicked"
                (click)="onPaymentClick(del_inst.value)"
              >
                {{ "checkout.confirm_order" | translate }}
                <span *ngIf="isLoading">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </span>
              </button>
            </div>

            <p
              class="text-danger mb-0 valid-danger-text mt-3"
              *ngIf="this.dlvrMsg != '' && showLang == 'en'"
            >
              {{ this.dlvrMsg }}
            </p>
            <p
              class="text-danger mb-0 valid-danger-text mt-3"
              *ngIf="this.dlvrMsg != '' && showLang == 'ar'"
            >
              {{ this.dlvrMsg }}
            </p>
            <a *ngIf="showShopping" [routerLink]="['/order-online']">{{
              "cart.continue_shopping" | translate
            }}</a>
          </div>
        </div>
        </div>

        <p *ngIf="shopStatus == 1" class="shop-closed">
          {{ "cart.shop_closed" | translate }}
        </p>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title main-heading">
            {{ "checkout.select_address" | translate }}
          </h5>
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 address mb-3" *ngFor="let adrs of allAdrs">
              <h4>{{ adrs.userName }}</h4>
              <p>{{ adrs.apartment }}</p>
              <p>{{ adrs.address_one }}</p>
              <p>{{ adrs.address_two }}</p>
              <p>{{ adrs.area }}</p>
              <p>{{ adrs.city }}</p>
              <p>{{ adrs.state }}</p>
              <p>{{ adrs.country }}</p>

              <div class="seladd">
                <input
                  type="radio"
                  id="adr{{ adrs.id }}"
                  class="mr-1"
                  name="adrs_id_2"
                  (change)="getAddrsId(adrsvl2)"
                  [attr.lat]="adrs.lat"
                  [attr.long]="adrs.long"
                  [attr.uname]="adrs.userName"
                  [attr.apartment]="adrs.apaetment"
                  [attr.adr-1]="adrs.address_one"
                  [attr.adr-2]="adrs.address_two"
                  [attr.area]="adrs.area"
                  [attr.city]="adrs.city"
                  [attr.state]="adrs.state"
                  [attr.country]="adrs.country"
                  value="{{ adrs.id }}"
                  #adrsvl2
                />
                <label for="adr{{ adrs.id }}">
                  {{ "checkout.deliver_thisaddress" | translate }}</label
                ><br />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            #closebutton
            class="btn close-btn btn-default"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
